/* ===== SHOPIFY CART SYNC ADAPTER (added for production) ===== */
(function(){
 var el=document.querySelector('[data-kei-variants]');
 if(!el)return;
 var MAP;try{MAP=JSON.parse(el.textContent);}catch(e){MAP={};}
 var REV={};Object.keys(MAP).forEach(function(k){REV[MAP[k].variant]=k;});
 var _add=window.addToCart;
 window.addToCart=function(id,name,price,tint){
  _add(id,name,price,tint);
  var v=MAP[id];if(!v||!v.variant)return;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.variant,quantity:1})})
   .then(function(r){if(!r.ok)throw 0;})
   .catch(function(){toast('Could not add \u2014 is the product Active?');});
 };
 var _ch=window.chQty;
 window.chQty=function(k,d){
  _ch(k,d);
  var v=MAP[k];if(!v||!v.variant)return;
  var q=(window.CART[k]?window.CART[k].qty:0);
  var up={};up[v.variant]=q;
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:up})}).catch(function(){});
 };
 window.keiCheckout=function(){window.location.href='/checkout';};
 /* hydrate from real cart on load */
 fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
  try{
   (c.items||[]).forEach(function(it){
    var k=REV[it.variant_id];if(!k)return;
    window.CART[k]={name:MAP[k].name,price:Math.round(it.price/100),qty:it.quantity,tint:MAP[k].tint};
   });
   if(window.renderCart)renderCart();
   if(window.updateFab)updateFab();
  }catch(e){}
 }).catch(function(){});
})();
